import { styled } from '@mui/material/styles';
import React from 'react';
import MuiChip, { ChipProps } from '@mui/material/Chip';

export const ChipsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  '& > *': {
    flexGrow: 1,
  },
  '& > *:not(:last-child)': {
    marginRight: theme.spacing(2),
  },
}));

export type StyledChipProps = { isActive: boolean } & ChipProps;

export const Chip = styled(({ isActive, ...props }: StyledChipProps) => <MuiChip {...props} />)(
  ({ isActive, theme }) => ({
    marginBottom: theme.spacing(3),
    color: isActive ? theme.palette.secondary.contrastText : theme.palette.text.primary,
    backgroundColor: isActive ? theme.palette.secondary.main : theme.palette.background.default,
    '&[class*="MuiChip-clickable"]': {
      '&:hover, &:focus': {
        backgroundColor: isActive ? theme.palette.secondary.main : theme.palette.secondary.light,
        color: theme.palette.secondary.contrastText,
      },
    },
  })
);
